module.exports = __webpack_public_path__ + "static/img/picc-icon.02de534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/template/picc-icon.png
// module id = P59E
// module chunks = 1